import React, { useState } from 'react';
import { GlobeIcon, ExternalLinkIcon } from './Icons';
import styles from '../styles/ContentCard.module.css';

/**
 * Partner Card Component
 * Displays recommended partner/company cards with optional logo/image
 *
 * Props:
 * - name: Partner name
 * - websiteUrl: Partner website URL
 * - bestFor: Description of what this partner is best for
 * - imageUrl: Optional logo/image URL
 * - description: Optional detailed description
 */
function PartnerCard({ name, websiteUrl, bestFor, imageUrl, description }) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleImageError = () => {
    setImageError(true);
    setImageLoaded(true);
  };

  // Extract domain from URL for display
  const displayDomain = websiteUrl ? new URL(websiteUrl).hostname.replace('www.', '') : '';

  return (
    <div className={styles.contentCard}>
      <div className={styles.contentCardHeader}>
        Recommended Partner
      </div>

      {imageUrl && !imageError && (
        <div className={styles.contentCardImage}>
          {!imageLoaded && (
            <div className={styles.imagePlaceholder}>
              <div className={styles.imageLoader}></div>
            </div>
          )}
          <img
            src={imageUrl}
            alt={`${name} logo`}
            onLoad={handleImageLoad}
            onError={handleImageError}
            style={{ display: imageLoaded ? 'block' : 'none' }}
            className={styles.image}
          />
        </div>
      )}

      <div className={styles.contentCardContent}>
        <div className={styles.contentCardTitle}>{name}</div>

        {bestFor && (
          <div className={styles.contentCardBestFor}>
            <strong>Best for:</strong> {bestFor}
          </div>
        )}

        {description && (
          <div className={styles.contentCardDescription}>
            {description}
          </div>
        )}

        <div className={styles.contentCardMeta}>
          <div className={styles.contentCardMetaItem}>
            <GlobeIcon size={16} /> {displayDomain}
          </div>
          <div className={styles.contentCardMetaItem}>
            <ExternalLinkIcon size={16} /> Visit Site
          </div>
        </div>
      </div>
    </div>
  );
}

export default PartnerCard;
